/* BOLTRON (page.boltron) · 03 Details explorer. snippets/boltron-details.liquid.
   Desktop (≥990px): thumbnail tabs swap the large image (crossfade in CSS).
   Mobile: the slides are a scroll-snap row; arrows scroll it, and the
   slide nearest the centre becomes active (name under the arrows). */
(function () {
  var desktop = window.matchMedia('(min-width: 990px)');

  Array.prototype.forEach.call(document.querySelectorAll('[data-bh-details]'), function (root) {
    var track = root.querySelector('[data-bh-details-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-bh-details-slide]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-bh-details-tab]'));
    var current = root.querySelector('[data-bh-details-current]');
    var total = slides.length;
    if (!track || total === 0) return;

    var active = 0;

    var setActive = function (index) {
      active = index;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });
      if (current) current.textContent = slides[index].getAttribute('data-label') || '';
    };

    var scrollToSlide = function (index) {
      var slide = slides[index];
      var left = slide.offsetLeft - (parseFloat(window.getComputedStyle(track).scrollPaddingLeft) || 0);
      track.scrollTo({ left: left, behavior: 'smooth' });
    };

    var go = function (index) {
      index = ((index % total) + total) % total;
      setActive(index);
      if (!desktop.matches) scrollToSlide(index);
    };

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { go(index); });
      tab.addEventListener('keydown', function (event) {
        var target = null;
        if (event.key === 'ArrowRight') target = index + 1;
        else if (event.key === 'ArrowLeft') target = index - 1;
        if (target === null) return;
        event.preventDefault();
        go(target);
        tabs[active].focus();
      });
    });

    var prev = root.querySelector('[data-bh-details-prev]');
    var next = root.querySelector('[data-bh-details-next]');
    if (prev) prev.addEventListener('click', function () { go(active - 1); });
    if (next) next.addEventListener('click', function () { go(active + 1); });

    /* The card whose snap position (its left edge) is nearest the scroll. */
    var nearest = function () {
      var pad = parseFloat(window.getComputedStyle(track).scrollPaddingLeft) || 0;
      var best = 0;
      var bestDist = Infinity;
      slides.forEach(function (slide, i) {
        var dist = Math.abs(slide.offsetLeft - pad - track.scrollLeft);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      return best;
    };

    /* Mobile: follow the user's own swipes. */
    var frame = 0;
    track.addEventListener('scroll', function () {
      if (desktop.matches) return;
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(function () {
        var best = nearest();
        if (best !== active) setActive(best);
      });
    }, { passive: true });

    /* Mobile: drag with a mouse too (touch already scrolls natively). Snap is
       paused while dragging, then the nearest card is brought into place. */
    var drag = null;
    track.addEventListener('pointerdown', function (event) {
      if (desktop.matches || event.pointerType !== 'mouse' || event.button !== 0) return;
      drag = { x: event.clientX, left: track.scrollLeft, moved: false, start: active, dx: 0 };
      track.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function (event) {
      if (!drag) return;
      var dx = event.clientX - drag.x;
      drag.dx = dx;
      if (Math.abs(dx) > 4) drag.moved = true;
      track.scrollLeft = drag.left - dx;
    });
    /* Release: move one card only when the user clearly dragged towards it
       (a fifth of a card); otherwise the current card settles back. */
    var endDrag = function () {
      if (!drag) return;
      var d = drag;
      drag = null;
      if (!d.moved) {
        track.classList.remove('is-dragging');
        return;
      }
      var threshold = slides[0].offsetWidth * 0.2;
      var index = d.start;
      if (d.dx <= -threshold) index = Math.min(d.start + 1, total - 1);
      else if (d.dx >= threshold) index = Math.max(d.start - 1, 0);
      setActive(index);
      scrollToSlide(index);
      /* Snap stays off until the glide to the chosen card has finished,
         otherwise it would grab the nearest card mid-way. */
      var done = false;
      var release = function () {
        if (done) return;
        done = true;
        track.classList.remove('is-dragging');
      };
      track.addEventListener('scrollend', release, { once: true });
      window.setTimeout(release, 700);
    };
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);
    /* No native image drag ghost while dragging the row. */
    track.addEventListener('dragstart', function (event) { event.preventDefault(); });

    root.classList.add('is-ready');
    setActive(0);
  });
})();
